import { NavLinks } from "./NavLinks.tsx";
import { HamburgerButton } from "./HamburgerButton.tsx";

export default function Header() {
  return (
    <header class="header">
      <div class="menu-container">
        <div class="menu-top">
          <a href="/">
            <img
              src="/img/logos/new-site-gagetech-logo.svg"
              alt="TECHNOLOGIES gage."
              class="logo"
              width={123.456}
              height={40}
            />
          </a>
          <HamburgerButton />
        </div>
        <nav class="nav-links">
          <NavLinks dropdown />
        </nav>
        <a class="cta-button" href="/contact">Contact Us</a>
      </div>
    </header>
  );
}
